module.exports = __webpack_public_path__ + "static/media/defaultC.a6e2e1a4.svg";